import React from 'react';

const AmplifierIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M4 2h16a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2z"
      strokeWidth="1.5"
    />
    <path
      d="M2 8h20"
      strokeWidth="1.5"
    />
    <circle cx="7" cy="5" r="1" fill="currentColor" stroke="none" />
    <circle cx="12" cy="5" r="1" fill="currentColor" stroke="none" />
    <circle cx="17" cy="5" r="1" fill="currentColor" stroke="none" />
    <path
      d="M6 15a6 6 0 0112 0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AmplifierIcon;
